/**
 * Les éléments graphiques dessinés par Dorian, repris tels quels.
 *
 * Ce sont des tracés à main levée, cohérents avec sa signature — une croix qui
 * n'est pas deux droites, un soulignement qui ondule. Les redessiner « proprement »
 * en CSS revenait à effacer sa main : c'est ce que j'avais fait, avec un « × »
 * typographique et un trait droit.
 *
 * Seule modification : la couleur passe en `currentColor` au lieu d'être figée
 * (blanc pour la croix, #3A3838 pour le soulignement), pour que le même tracé
 * serve sur fond clair comme sur fond sombre.
 */

/** Croix de fermeture. Tracés d'origine : `public/croixclose.svg`. */
export function Croix({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 22 21.7" aria-hidden="true" focusable="false">
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2656"
        strokeLinecap="round"
        strokeMiterlimit="10"
      >
        <path d="M2.8,1.1c9.5,7.1,18.1,19.5,18.1,19.5" />
        <path d="M20.6,1.9C12.9,9.3,2.4,18.4,1.1,20" />
      </g>
    </svg>
  );
}

/** Triangle de lecture. Tracé d'origine : `public/btn_play.svg`. */
export function Lecture({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="-945 516.1 28.5 48.9"
      aria-hidden="true"
      focusable="false"
    >
      <polygon fill="currentColor" points="-944.6,516.5 -944.6,563.2 -917.4,539 " />
    </svg>
  );
}

/**
 * Soulignement de la rubrique active. Tracé d'origine : `public/rollover_rubrique.svg`.
 *
 * Affiché À SON RATIO NATUREL. Une première version l'étirait sur la largeur du
 * libellé (`preserveAspectRatio="none"`) : le tracé de Dorian ondule, l'étirer le
 * déformait. Le code d'origine l'affiche en 30 px de large, hauteur libre.
 */
export function SoulignementRubrique({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="-943.2 539.8 31 5.5"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M-942,541.3c17.4-1.1,28.6,2.6,28.6,2.6"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeMiterlimit="10"
      />
    </svg>
  );
}
